import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import * as _ from 'lodash';
import { createSidebar } from '../../redux/actions/general/sidebar';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import { __, getActiveStage, redirect } from '../../core/utils';
import styles from '../../styles/views/plans/PlanVersionPreview.scss';
import {
  readPlanVersion,
  readPlanVersionAnotation,
  readWorkingSetPlan,
  updatePlanVersionAnotation,
} from '../../redux/actions/table/working_set_plans';
import ArrowLeftMiddleIcon from '../../assets/images/arrow-left-middle-15x15.svg';
import ArrowRightSmallIcon from '../../assets/images/arrow-right-small-15x15.svg';
import queryString from 'query-string';
import { connect } from 'react-redux';
import classNames from 'classnames';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import CompareIcon from '../../assets/images/compare-15x15.svg';
import { isSafari } from 'react-device-detect';
import Tooltip from '../../components/Tooltip';

// NEW
import Localization from '../../helpers/Localization';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';

// NEW
import { updateTool } from '../../redux/actions/fabric_overlay';
import Viewer from './components/Viewer';
import Toolbar from './components/Toolbar/Toolbar';
import {
  findTaskObjectOnCanvas,
  resetObjectStyle,
  selectObjectStyle,
} from './helpers/fabricHelpers';
import {
  readTask,
  listPlanVersionTasks,
} from '../../redux/actions/table/all_tasks';
import TasksFlyout from '../../flyouts/tasks/TasksFlyout';
import WorkingSetPlansFlyout from '../../flyouts/working_set_plans/WorkingSetPlansFlyout';
import { getStatusColor } from './components/Task/taskStatusColors';
import TitleBar from '../../containers/TitleBar';
import ArrowDoubleLeftMiddleIcon from '../../assets/images/arrow-double-left-middle-15x15.svg';
import ArrowRightMiddleIcon from '../../assets/images/arrow-right-middle-15x15.svg';
import ArrowDoubleRightMiddleIcon from '../../assets/images/arrow-double-right-middle-15x15.svg';
import ReactDOM from 'react-dom';

const PlanVersionPreview = (props) => {
  const [planVersionData, setPlanVersionData] = useState(null);
  const [planVersionAnnotationData, setPlanVersionAnnotationData] =
    useState(null);
  const [previewPlan, setPreviewPlan] = useState(null);
  const [taskPreview, setTaskPreview] = useState(null);

  const [planVersionTasks, setPlanVersionTasks] = useState(null);
  const prevTaskStatusRef = useRef();

  const { viewer, fabricOverlay } = props?.fabric_overlay;

  const plan_version_id = props.match.params.plan_version;

  useEffect(() => {
    readPlanVersion(plan_version_id).then(({ response }) => {
      const plan_version_data = response.data;

      setPlanVersionData(plan_version_data);

      listPlanVersionTasks(plan_version_id).then(({ response }) => {
        setPlanVersionTasks(response.data);

        readPlanVersionAnotation(plan_version_id).then(({ response }) => {
          setPlanVersionAnnotationData(response.data);
          setPlanVersionData(plan_version_data);
        });
      });

      listActiveModules();

      readWorkingSetPlan(response.data.plan.id).then(({ response }) => {
        setPreviewPlan(response.data);
      });

      enableProjectsDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/working')
      );
      enableStagesDropdown(({ stage_id }) =>
        redirect('/stages/' + stage_id + '/plans/working')
      );

      const approval = _.get(
        queryString.parse(props.location.search),
        'approval',
        undefined
      );

      createSidebar({
        title: __('submenu.title.plans'),
        items: [
          {
            title: __('submenu.title.current-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/current',
          },
          {
            title: __('submenu.title.working-set'),
            link: () => '/stages/' + getActiveStage() + '/plans/working',
            active: _.isUndefined(approval),
          },
          {
            title: __('submenu.title.uploads'),
            link: () => '/stages/' + getActiveStage() + '/plans/uploads',
          },
          {
            title: __('submenu.title.deliveries'),
            link: () => '/stages/' + getActiveStage() + '/deliveries',
          },
          {
            title: __('submenu.title.approvals'),
            link: () => '/stages/' + getActiveStage() + '/approvals',
            active: !_.isUndefined(approval),
            items: !_.isUndefined(approval) && [
              {
                title: __('submenu.title.approvals.pending'),
                link: () =>
                  '/stages/' + getActiveStage() + '/approvals/pending',
                active: approval == 'pending',
              },
              {
                title: __('submenu.title.approvals.approved'),
                link: () =>
                  '/stages/' + getActiveStage() + '/approvals/approved',
                active: approval == 'approved',
              },
              {
                title: __('submenu.title.approvals.rejected'),
                link: () =>
                  '/stages/' + getActiveStage() + '/approvals/rejected',
                active: approval == 'rejected',
              },
            ],
          },
        ],
      });
    });
  }, []);

  // useEffect(() => {
  //   updateTool({ tool: 'hand' });
  // }, [planVersionAnnotationData, fabricOverlay]);

  useEffect(() => {
    if (props.task_table?.clicked_row) {
      readTask(props.task_table?.clicked_row).then(({ response }) => {
        prevTaskStatusRef.current = response.data.status;

        setTaskPreview(response.data);
      });
    }
  }, [props.task_table?.clicked_row]);

  useEffect(() => {
    const currentStatus = props.task_table?.flyout?.status;
    const prevStatus = prevTaskStatusRef.current;

    if (prevStatus !== undefined && currentStatus !== prevStatus) {
      if (props.task_table?.clicked_row && currentStatus) {
        const canvas = fabricOverlay.fabricCanvas();

        const taskObj = findTaskObjectOnCanvas(
          canvas,
          props.task_table?.clicked_row
        );

        if (taskObj) {
          const color = getStatusColor(currentStatus);
          taskObj.set({
            stroke: color,
            fill: color,
          });
          canvas.requestRenderAll();
        }
      }

      prevTaskStatusRef.current = currentStatus;
    }
  }, [props.task_table?.flyout?.status]);

  const handleSubmit = (fabricOverlay) => {
    const canvas = fabricOverlay.fabricCanvas();
    const activeObject = canvas.getActiveObject();
    activeObject && resetObjectStyle(activeObject);

    const allObjects = canvas
      .getObjects()
      .filter((obj) => obj.objectType !== 'controlpoint');

    const serializedObjects = {
      objects: allObjects.map((obj) =>
        obj.toObject([
          'objectType',
          'originalLeft',
          'originalTop',
          'taskID',
          'userID',
          'lockMovementX',
          'lockMovementY',
          'userFullName',
        ])
      ),
    };
    // const serializedObjects = {
    //   objects: {},
    // };
    activeObject && selectObjectStyle(activeObject);
    updatePlanVersionAnotation(
      plan_version_id,
      JSON.stringify(serializedObjects)
    );
  };

  const _goBack = () => {
    window.previousLocation
      ? window.history.back()
      : redirect('/stages/' + getActiveStage() + '/plans/working');
  };

  const approval = _.get(
    queryString.parse(props.location.search),
    'approval',
    undefined
  );

  let first_plan_id, last_plan_id, prev_plan_id, next_plan_id;

  if (!_.isEmpty(props.table?.data) && planVersionData) {
    first_plan_id = _.first(props.table?.data).last_version.id;
    last_plan_id = _.last(props.table?.data).last_version.id;

    prev_plan_id =
      _.get(props.table?.data, [
        _.findIndex(props.table?.data, ['id', planVersionData.plan.id]) - 1,
        'last_version',
        'id',
      ]) || first_plan_id;
    next_plan_id =
      _.get(props.table?.data, [
        _.findIndex(props.table?.data, ['id', planVersionData.plan.id]) + 1,
        'last_version',
        'id',
      ]) || last_plan_id;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.toolbar}>
        <div className={styles.title}>
          {planVersionData && (
            <>
              {_.isUndefined(approval) ? (
                <>
                  <TitleBar
                    title={__('submenu.title.working-set')}
                    loading={false}
                  />

                  <ArrowRightSmallIcon />
                  {planVersionData.plan.discipline.id == null
                    ? planVersionData.plan.discipline.description + '*'
                    : _.get(props.localization.disciplines, [
                        planVersionData.plan.discipline.id,
                        'name',
                      ])}
                </>
              ) : (
                'Approvals'
              )}
              <ArrowRightSmallIcon />
              {_.filter(
                [planVersionData.plan.code, planVersionData.plan.title],
                _.identity
              ).join(': ')}
            </>
          )}
        </div>
      </div>
      <div className={styles.header}>
        {planVersionData && (
          <>
            <div className={styles.back} onClick={_goBack}>
              <Tooltip text={__('plans.tooltip.icon.back-to-list')}>
                <ArrowLeftMiddleIcon />
              </Tooltip>{' '}
              Back
            </div>
            <div className={classNames(styles.actions)}>
              {/* {planVersionData.versions > 1 && isSafari && (
                <Tooltip text='Compare tool is not available in Safari browser'>
                  <CompareIcon
                    className={classNames(
                      compare && styles.active,
                      styles.disabled
                    )}
                  />
                </Tooltip>
              )} */}
              {/* {planData.versions > 1 && !isSafari && (
                <Tooltip text={__('plans.tooltip.icon.plan-version-compare')}>
                  <CompareIcon
                    className={classNames(compare && styles.active)}
                    onClick={_toggleCompareTool}
                  />
                </Tooltip>
              )} */}
              <Tooltip text={__('plans.tooltip.icon.plan-properties')}>
                <InfoPositiveIcon
                  className=''
                  onClick={() => {
                    props.actions.setTableParams({
                      clicked_row: previewPlan.id,
                    });
                  }}
                />
              </Tooltip>
            </div>
          </>
        )}
      </div>

      {/* Body */}

      <div className={styles.content}>
        <Viewer
          plan={planVersionData?.plan}
          annotations={planVersionAnnotationData}
          onSubmit={handleSubmit}
          fabricOverlay={fabricOverlay}
          planVersionTasks={planVersionTasks}
        />
        <div id='toolbar' className={styles.toolbar}>
          <Toolbar plan={planVersionData?.plan} onSubmit={handleSubmit} />
        </div>
      </div>

      {/* Footer */}

      {!_.isEmpty(props.table?.data) && planVersionData && (
        <div className={styles.footer}>
          <div className={styles.pagination}>
            <Tooltip text={__('content.tooltip.table.first-page')}>
              <ArrowDoubleLeftMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + first_plan_id, true)
                }
              />
            </Tooltip>
            <Tooltip text={__('content.tooltip.table.prev-page')}>
              <ArrowLeftMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + prev_plan_id, true)
                }
              />
            </Tooltip>
            <span className={classNames(styles.page, styles.active)}>
              {planVersionData.plan.code}
            </span>
            <Tooltip text={__('content.tooltip.table.next-page')}>
              <ArrowRightMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + next_plan_id, true)
                }
              />
            </Tooltip>
            <Tooltip text={__('content.tooltip.table.last-page')}>
              <ArrowDoubleRightMiddleIcon
                onClick={() =>
                  redirect('/plans/versions/' + last_plan_id, true)
                }
              />
            </Tooltip>
          </div>
        </div>
      )}

      {/* Flyout */}

      <div
        className={classNames(
          styles.flyout,
          (props.table?.clicked_row || props.task_table?.clicked_row) &&
            styles.active
        )}
      >
        {props.table?.clicked_row && previewPlan && (
          <WorkingSetPlansFlyout
            data={previewPlan}
            readAction={(id) => {
              return new Promise((resolve) => {
                readWorkingSetPlan(planVersionData.plan.id).then(
                  ({ response }) => {
                    if (
                      previewPlan.status == '1' &&
                      response.data.status == '0'
                    ) {
                      readPlanVersion(props.match.params.plan_version).then(
                        ({ response }) => {
                          setPlanVersionData(response.data);

                          resolve(response);
                        }
                      );
                    }

                    this.setState({ preview: response.data });
                  }
                );
              });
            }}
          />
        )}
      </div>

      {props.task_table?.clicked_row &&
        taskPreview &&
        viewer &&
        ReactDOM.createPortal(
          <div
            style={{ top: 0 }}
            className={classNames(
              styles.flyout,
              (props.table?.clicked_row || props.task_table?.clicked_row) &&
                styles.active
            )}
          >
            <TasksFlyout
              data={taskPreview}
              readAction={(task_id) => {
                return new Promise((resolve) => {
                  readTask(task_id).then(({ response }) => {
                    setTaskPreview(response.data);

                    resolve(response);
                  });
                });
              }}
            />
          </div>,
          viewer.container
        )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fabric_overlay: state.fabric_overlay,
    task_table: state.table['all_tasks'],
    table: state.table['working_set_plans'],
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.working_set_plans/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(subscribe(Localization, 'localization')(PlanVersionPreview))
);
